<script lang="ts">
    import {onMount} from "svelte";
    import PortalView from "../common/Portal/PortalView.svelte";
    import SpaceAuthorityView from "./Authority/SpaceAuthorityView.svelte";
    import PageTrailView from "./PageTrailView.svelte";

    export let space;
    export let pageTrailMap;

    onMount(() => {
    });


</script>

<PortalView portalTargetSelector="#header-left-portal-target">

    <div class="space-information-view">
        <span class="separate"></span>
        <div class="space-name-area">
            <a href={`/#/space/${space.unique_id}`}>
                {space.name }
            </a>
        </div>

        <SpaceAuthorityView space={space}/>

        <PageTrailView pageTrailMap={pageTrailMap}/>

    </div>
</PortalView>

<style lang="scss">
    .space-information-view {
        display: flex;
        gap: 16px;

        .separate {
            margin-left: 12px;
            margin-right: 12px;
            background-color: var(--bana-white-color);
            width: 1px;
            height: 1.5em;
        }

        .space-name-area {
        }

        .authority-information-button {
            margin-left: 1em;
            cursor: pointer;
        }

        .space-language-area {
            margin-left: 24px;
        }

        .bana-resource-area {
            font-size: 0.8em;
            border-style: solid;
            border-width: 1px;
            padding-left: 0.5em;
            padding-right: 0.5em;
            cursor: pointer;

            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .not-found-message {
        padding: 60px;

        .description {
            opacity: 0.5;
        }
    }

</style>